














import { Component, Vue } from "vue-property-decorator";
import { ajaxEventInfo } from "@/server";

// mixins
import MyHomeMixins from '../MixinsFunc/MyHomeMixins'; 

// 声明组件*****************
@Component({
  components: {
    
  },
  mixins: [MyHomeMixins]
})
export default class AlarmHistoryInfo extends Vue {
  // 属性*****************
  private loading: boolean = true;
  private alarmEventData = [
    [
      {
        id: "device_model_name",
        name: "部件名称",
        value: '',
        jpath: "info_device.name"
      },
      {
        id: "compos_specific",
        name: "位置",
        value: '',
        jpath: "info_device.specific"
      },
      {
        id: "confirm_type_name",
        name: "当前状态",
        value: '',
        jpath: "rt_event_confirm.enum_device_status.name"
      },
      {
        id: "confirm_type_id",
        name: "当前状态",
        value: '',
        jpath: "rt_event_confirm.enum_confirm_type.id",
        show: false
      },
      {
        id: "event_create_time",
        name: "报警时间",
        value: '',
        jpath: "rt_event_confirm.create_time"
      },
      {
        id: "event_accept_end_time",
        name: "恢复时间",
        value: '',
        jpath: "rt_event_confirm.accept_end_time"
      },
      
      {
        id: "subdistrict_name",
        name: "小区",
        value: '',
        jpath: "info_subdistrict.name",
        show: false
      },
      {
        id: "building_name",
        name: "建筑",
        value: '',
        jpath: "info_building.building_name",
        show: false
      },
      {
        id: "floor_name",
        name: "楼层",
        value: '',
        jpath: "info_floor.name",
        show: false
      },
      {
        id: "room_id",
        name: "单元号",
        value: '',
        jpath: "info_things_compos.room_id",
        show: false
      },
    ],
  ]
  created(): void {
    document.title = "报警详情";
  }
  
  async mounted () {
    const status = await this['getUserInfo']();
    if(status==0){
      this.getEvent();
    }
  }

  // 获取报警详情
  private getEvent(): void {
    this['$indicator'].open({
        text: '加载中...',
    });
    return ajaxEventInfo({
      uid: this.$store.state.user_info.info_user.user_id,
      // uuid: '9c467ced-c615-4246-991f-fae38e420359',
      uuid: this.$route.query.uuid
    }).then(res=>{
      this['$getDataInit'](this.alarmEventData, res.data);
      this.alarmEventData[0].forEach(x=>{
        if(x.id=='device_name'){
          x.value = this['$getObjectValue'](res.data,'info_device.name')
                  ?this['$getObjectValue'](res.data,'info_device.name')
                  :this['$getObjectValue'](res.data,'info_device.enum_device_model.name');
        }

        if(x.id=='confirm_type_id'){
          if(x.value=='0'){
            this.alarmEventData[0].find(x=>{
              if(x.id=='event_accept_end_time'){
                x.show = false;
                return true
              }
            })
          }
          else{
             this.alarmEventData[0].find(x=>{
              if(x.id=='event_accept_end_time'){
                x.show = true;
                return true
              }
            })
          }
        }
        if(x.id==='device_model_name'){
          x.value=x.value||this['$getObjectValue'](res.data,'rt_event_confirm.enum_device_model.name');
        }
      })
      this.loading = true;
    }).catch(error=>{
      console.log(error);
      this.loading = false;
    }).finally(data=>{
      this['$indicator'].close();
    })
  }


  // computed
  get alarmValue(): string {
    let subdistrict: string = this.alarmEventData[0].find(x=>x.id=='subdistrict_name').value;
    let building_name: string = this.alarmEventData[0].find(x=>x.id=='building_name').value;
    let floor_name: string = this.alarmEventData[0].find(x=>x.id=='floor_name').value;
    let room_id: string = this.alarmEventData[0].find(x=>x.id=='room_id').value;
    let device_model_name: string = this.alarmEventData[0].find(x=>x.id=='device_model_name').value;

    let address:string=this.alarmEventData[0].find(x=>x.id=='compos_specific').value;

    if(!subdistrict||subdistrict==='-1'||subdistrict==='--'){
      subdistrict = '未知小区';
    }
    if(!room_id||room_id==='-1'||subdistrict==='--'){
      room_id = '未知房间';
    } else {
      room_id += '房间';
    }

    // return subdistrict+building_name+floor_name+room_id+' '+device_model_name+'发生报警';
    
    return (address?address:'--')+' '+device_model_name+'发生报警';

  }


}
